<div id="tsq-navbar">
  <div class="navbar-left-wrapper">
    <ng-content select=".tsq-navbar-adm-picture-wrapper"></ng-content>
  </div>

  <div class="dynamic-content-wrapper">
    <ng-content></ng-content>
  </div>
</div>
